import { type FactGroup } from '@/karehero-app/tell-us-once/intake/FactList';

// What the settings sheet holds about the person using the app, as opposed to
// the person they care for.
//
// Their own details, kept apart from the care record on purpose: the profile is
// Margaret's and this is theirs, and the two have been asked for at different
// points by different questions. Same rows and same editor as the profile, so
// changing a name works the same way in both places.
//
// The email is the one they signed in with, which is why it is here rather than
// only in the line under Sign out: an account you cannot see is an account you
// cannot tell is the wrong one.
/** The account they signed in with. One address, so the sheet and the details agree. */
export const ACCOUNT_EMAIL = 'soph.qualleyy@email.com';

export const ACCOUNT_FACTS: FactGroup[] = [
  {
    label: 'You',
    rows: [
      {
        id: 'account-name',
        label: 'Legal name',
        value: 'Vez Maxwell',
        control: 'parts',
        parts: [
          { label: 'First name', value: 'Vez' },
          { label: 'Last name', value: 'Maxwell' },
        ],
        join: ' ',
      },
      {
        id: 'account-preferred',
        label: 'What we call you',
        value: 'Vez',
      },
      {
        id: 'account-relationship',
        label: 'Your relationship to Margaret',
        value: 'Daughter',
        control: 'choice',
        choices: [
          'Daughter',
          'Son',
          'Partner',
          'Sibling',
          'Friend',
          'Other relative',
        ],
      },
    ],
  },
  {
    label: 'How we reach you',
    rows: [
      {
        id: 'account-email',
        label: 'Email',
        value: ACCOUNT_EMAIL,
      },
      {
        id: 'account-phone',
        label: 'Mobile',
        value: '07700 900461',
      },
    ],
  },
];
